export default __webpack_public_path__ + "static/media/envelope-regular-black.fe2b60b5.png";